import React, { useState, useEffect } from 'react';
import desktopVideo from '../Assets/HeroVideo-Desktop.mp4';
import mobileVideo from '../Assets/HeroVideo-Mobile.mp4';
import './SplashLoader.css';

const SPLASH_DURATION = 2000; // 3 seconds

const SplashLoader = ({ onFinish }) => {
    const [hiding, setHiding] = useState(false);

    useEffect(() => {
        // Start fade-out slightly before the full duration so it feels seamless
        const fadeTimer = setTimeout(() => setHiding(true), SPLASH_DURATION - 400);
        // Notify parent to unmount after full duration
        const doneTimer = setTimeout(() => onFinish(), SPLASH_DURATION);

        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(doneTimer);
        };
    }, [onFinish]);

    return (
        <div className={`splash-loader ${hiding ? 'splash-hiding' : ''}`}>
            {/* Desktop video — hidden on small screens via CSS */}
            <video
                className="splash-video splash-desktop"
                src={desktopVideo}
                autoPlay
                muted
                playsInline
                loop
            />
            {/* Mobile video — shown only on small screens via CSS */}
            <video
                className="splash-video splash-mobile"
                src={mobileVideo}
                autoPlay
                muted
                playsInline
                loop
            />
        </div>
    );
};

export default SplashLoader;
